import apiUseCases from "@src/cloud-connect/api";
import { PutUpdateDashboardTilesPayloadBuilder } from "./put-update-dashboard-tiles-payload-builder";

export const putUpdateDashboardTiles = async (
  dashboard_id,
  source_id,
  namespace,
  dashboardDataTiles,
) => {
  const payload = new PutUpdateDashboardTilesPayloadBuilder(
    dashboard_id,
    source_id,
    namespace,
    dashboardDataTiles,
  ).build();

  const data = await apiUseCases.updateDashboard(payload);
  return data;
};
